module.exports = __webpack_public_path__ + "static/media/starwars.4dba74c6.png";